import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import Select from 'react-select';
import MyEditor from '../../../Components/editor/MyEditor';
import { API, BACKEND_HOST, getDataFromUrl } from '../../../api';
import axios from 'axios';
import { Button } from '@/Components/ui';
import { dialogService } from "@/utils/dialogService";
const SupplyProductForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const fileInputRef = React.useRef(null);
    const detailImgFileInputRef = React.useRef(null);
    const [name, setName] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [price, setPrice] = React.useState(0);
    const [imageUrl, setImageUrl] = React.useState(null);
    const [image, setImage] = React.useState(null);
    const [detailImgUrl, setDetailImgUrl] = React.useState(null);
    const [detailImg, setDetailImg] = React.useState(null);
    const [productState, setProductState] = React.useState(null);
    const [availableStartDate, setAvailableStartDate] = React.useState(null);
    const [availableEndDate, setAvailableEndDate] = React.useState(null);
    // const [discount, setDiscount] = React.useState(0);
    const [count, setCount] = React.useState(0); // 수량 stock_count
    const [siteOptions, setSiteOptions] = React.useState([]);
    const [availableSites, setAvailableSites] = React.useState([]);
    const fetchSiteOptions = () => {
        getDataFromUrl(`${BACKEND_HOST}/sites/camps/`)
            .then((data) => {
            // console.log(data);
            const _sites = data.filter((item) => !!item.subdomain).map((item) => {
                return {
                    value: item.id,
                    label: item.name
                };
            });
            setSiteOptions(_sites);
        })
            .catch((e) => { console.log(e); });
    };
    const handleImageFiles = (e) => {
        const files = e.target.files;
        if (files.length !== 0) {
            setImage(files[0]);
        }
    };
    const handleDetailImgFiles = (e) => {
        const files = e.target.files;
        if (files.length !== 0) {
            setDetailImg(files[0]);
        }
    };
    React.useEffect(() => {
        if (id !== '0' && siteOptions.length > 0) {
            API.get(`${BACKEND_HOST}/supply/product/${id}`)
                .then(res => { fillStates(res.data); })
                .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
        }
    }, [id, siteOptions]);
    const fillStates = (data) => {
        console.log("fillStates", data);
        setName(data["name"]);
        setDescription(data["descript"]);
        setImageUrl(data["thumbnail"]);
        setDetailImgUrl(data["detail_img"]);
        setAvailableStartDate(data["available_start_date"]);
        setAvailableEndDate(data["available_end_date"]);
        setProductState(data["state"]);
        setPrice(data["price"]);
        setCount(data["stock_count"]);
        if (data["sites"]) {
            let tmpSites = data["sites"]
                .filter((item) => !!siteOptions.find((option) => option.value === item))
                .map((item) => {
                const _item = siteOptions.find((option) => option.value === item);
                if (_item)
                    return {
                        value: _item.value,
                        label: _item.label
                    };
            });
            console.log("tmpSites", tmpSites);
            setAvailableSites(tmpSites);
        }
    };
    const sendData = async () => {
        const [data, jsondata] = await checkData();
        if (data === null)
            return;
        console.log("sendData", jsondata);
        API.post(`${BACKEND_HOST}/supply/product/`, data, {
            headers: {
                "content-type": "multipart/form-data"
            }
        })
            .then((res) => {
            console.log("supply", res);
            API.patch(`${BACKEND_HOST}/supply/product/${res.id}/`, jsondata).then(async (res) => {
                await dialogService.handleAlert("update ok");
                navigate(`/supply-product-list`);
            });
        })
            .catch(async (err) => {
            console.log(err);
            await dialogService.handleAlert("error " + JSON.stringify(err), { force: "error" });
        });
    };
    const updateData = async () => {
        const [data, jsondata] = await checkData();
        if (data === null)
            return;
        console.log("updateData", data);
        API.patch(`${BACKEND_HOST}/supply/product/${id}/`, data, {
            headers: {
                "content-type": "multipart/form-data"
            }
        })
            .then((res) => {
            console.log("supply", res);
            API.patch(`${BACKEND_HOST}/supply/product/${id}/`, jsondata).then(async (res) => {
                await dialogService.handleAlert("update ok");
                navigate(`/supply-product-list`);
            });
        })
            .catch(async (err) => {
            console.log(err);
            await dialogService.handleAlert("error " + JSON.stringify(err), { force: "error" });
        });
        return;
    };
    const getDate = (dateObj) => {
        if (typeof dateObj === "string")
            return dateObj;
        console.log(dateObj);
        let date = dateObj[0].getFullYear() + "-" + (dateObj[0].getMonth() + 1) + "-" + dateObj[0].getDate();
        return date;
    };
    const checkData = async () => {
        if (!name || !price || !description) {
            await dialogService.handleAlert("필수 입력값이 없습니다.");
            return [null, null];
        }
        let data = new FormData();
        data.append("name", name);
        // image default value 작동 안 됨.
        if (image)
            data.append("thumbnail", image);
        if (detailImg)
            data.append("detail_img", detailImg);
        data.append("descript", description);
        if (availableStartDate)
            data.append("available_start_date", getDate(availableStartDate));
        if (availableEndDate)
            data.append("available_end_date", getDate(availableEndDate));
        data.append("state", productState);
        data.append("price", price);
        data.append("stock_count", count);
        // data.append("sites", packages.map((item) => item.value));
        const jsondata = {
            name: name,
            descript: description,
            available_start_date: availableStartDate ? getDate(availableStartDate) : null,
            available_end_date: availableEndDate ? getDate(availableEndDate) : null,
            state: productState,
            stock_count: count ? count : 0,
            price: price,
            sites: availableSites.map((item) => item.value)
        };
        return [data, jsondata];
    };
    React.useEffect(() => {
        fetchSiteOptions();
    }, []);
    return (<React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <BreadCrumb title="발주상품 등록 및 수정" pageTitle="발주상품"/>

                    <div className="flex flex-wrap -mx-3 gap-y-4 mb-3">
                        <div className="col-sm-auto">
                            <div>
                                <h4 className="card-title mb-0 flex-grow-1">등록 및 수정</h4>
                            </div>
                        </div>
                        <div className="col-sm-3 ms-auto">
                            <div className="d-flex justify-content-sm-end gap-2">
                                {(id !== '0') ?
            <Button onClick={updateData} id="create-btn" color="success" className="add-btn me-1">
                                            Update
                                        </Button> :
            <Button onClick={sendData} id="update-btn" color="success" className="add-btn me-1">
                                            Create
                                        </Button>}
                                <Button onClick={() => { navigate(`/supply-product-list`); }} id="cancel-btn" color="danger" className="add-btn me-1">
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full px-3">
                            <div className="card">
                                <div className="card-body">
                                    <div className="live-preview">
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="firstNameinput" className="form-label">발주상품명</label>
                                                    <input type="text" className="form-control" placeholder="발주상품명" id="name" value={name} onChange={(e) => (setName(e.target.value))} maxLength="50"/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-1/3 px-3">
                                                {imageUrl ? <div>
                                                    <img src={`${imageUrl}`} alt="발주상품이미지" width="100%" style={{ maxHeight: "200px" }}/>
                                                </div> : null}
                                                <div>
                                                    <label htmlFor="formFile" className="form-label">발주상품이미지</label>
                                                    <input className="form-control" type="file" id="formFile" accept="image/jpg, image/jpeg, image/png" ref={fileInputRef} onChange={handleImageFiles}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-1/3 px-3">
                                                {detailImgUrl ? <div>
                                                    <img src={`${detailImgUrl}`} alt="발주상품 상세이미지" width="100%" style={{ maxHeight: "200px" }}/>
                                                </div> : null}
                                                <div>
                                                    <label htmlFor="detailImgFile" className="form-label">발주상품 상세이미지</label>
                                                    <input className="form-control" type="file" id="detailImgFile" accept="image/jpg, image/jpeg, image/png" ref={detailImgFileInputRef} onChange={handleDetailImgFiles}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="formStartDate" className="form-label">판매게시일</label>
                                                    <CommonDatePicker value={availableStartDate} onChange={setAvailableStartDate} className="form-control" options={{
        }}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="formEndDate" className="form-label">판매종료일</label>
                                                    <CommonDatePicker value={availableEndDate} onChange={setAvailableEndDate} className="form-control" options={{
        }}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="formProductState" className="form-label">상품상태</label>
                                                    <Select name="productState" options={[
            { value: "노출중", label: "노출중" },
            { value: "숨김", label: "숨김" },
            { value: "품절", label: "품절" },
        ]} className="basic-multi-select" classNamePrefix="select" onChange={(e) => { setProductState(e.value); }} value={{ value: productState, label: productState }}/>
                                                    {/* <input type="checkbox" className="form-control" placeholder="사용여부" id="formProductState" checked={isActive} onChange={(e) => (setIsActive(e.target.checked))} /> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="formPrice" className="form-label">금액</label>
                                                    <input type="number" className="form-control" placeholder="할인금액" id="formPrice" value={price} onChange={(e) => (setPrice(e.target.value))}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="formCount" className="form-label">재고수량</label>
                                                    <input type="number" className="form-control" placeholder="수량" id="count" value={count} onChange={(e) => (setCount(e.target.value))}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-1/3 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="formCount" className="form-label">노출지점(다중선택)</label>
                                                    <Select isMulti name="packages" options={siteOptions} className="basic-multi-select" classNamePrefix="select" onChange={(e) => { setAvailableSites(e); }} value={availableSites}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full px-3">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title mb-0">상세설명</h4>
                                </div>
                                <div className="card-body">
                                    <div>
                                        <MyEditor value={description} onChange={setDescription} noImage={true}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
};
export default SupplyProductForm;
